import { io } from "socket.io-client";

// export const socket = io("http://localhost:1337");
export const socket = io("https://evd-management.herokuapp.com");
